import { notification } from "antd";
import { get } from "lodash";
import { IoCheckmarkCircleOutline } from "react-icons/io5";
import { COLORS } from "shared/style/colors";
import { KEYS } from "utils/constants";

export const sendB2CQuote = ({
  project,
  processId,
  insurancePlanId,
  subscriptionId,
  insurancePlan,
  possibleStatus,
  addLink,
  generateQuoteDocuments,
  sendQuoteMutation,
  onError,
}) => {
  if (!get(project, "visible") && get(project, "fields.shouldBeHidden")) {
    return Promise.resolve();
  }

  return new Promise((resolve, reject) => {
    generateQuoteDocuments({
      variables: {
        data: {
          project: { id: project.id },
          insurancePlans: [{ id: insurancePlanId }],
        },
      },
      onCompleted: () => {
        const source = localStorage.getItem(KEYS.SOURCE);
        addLink({
          variables: {
            data: {
              url: get(
                insurancePlan,
                "config.generatedUrl",
                `${process.env.REACT_APP_BASE_URL}/#/public/process/init/${source}`,
              ),
              project: { id: project.id },
              subscription: { id: subscriptionId },
              fields: {
                process: { id: processId },
                status: { id: get(possibleStatus, "nextStatus") },
              },
            },
          },
          onCompleted: ({ addLink: linkData }) => {
            sendQuoteMutation({
              variables: {
                data: {
                  link: linkData?.id,
                  project: { id: project.id },
                  insurancePlans: [{ id: insurancePlanId }],
                },
              },
              onCompleted: () => {
                notification.open({
                  message: "Devis envoyé",
                  duration: 5,
                  icon: <IoCheckmarkCircleOutline color={COLORS.C_SUCCESS} />,
                });
                resolve();
              },
              onError: (error) => {
                onError?.(error);
                reject(error);
              },
            });
          },
          onError: (error) => {
            onError?.(error);
            reject(error);
          },
        });
      },
      onError: (error) => {
        onError?.(error);
        reject(error);
      },
    });
  });
};
